import { Codification } from './Codification';
import { DoorLock } from './DoorLock';
import { DoorTimer } from './DoorTimer';
import { IOptionItem } from './IOptionItem';
export class Game implements IOptionItem {

    public static MIN_TRIES: number = 8;
    public static MAX_TRIES: number = 30;
    constructor(
        public id?: number,
        public timer?: DoorTimer,
        public lock?: DoorLock,

    ) {

    }
    public static fromData(data: any) {
        if (!data) return null;
        let g = new Game(
            data.id,
            DoorTimer.fromData(data.timer),
            DoorLock.fromData(data.lock),

        )
        return g;
    }
    public get time(): number {
        return this.timer ? this.timer.time : 0;
    }

    public get code() {
        return this.lock?.code;
    }

    public get image() {
        return this.lock.lock.image;
    }
    public get tries() {
        return this.lock.lock.tries;
    }
    public get value() {
        return this.lock.lock.digits + " Dig. - " + this.timer.timer.value;
    }

    public get codification() {
        return this.lock ? this.lock.codification : new Codification();
    }


}